/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Route, Routes } from "react-router-dom";
import React, { Suspense, lazy } from "react";
import RequireAuth from "./hooks/RequireAuth";
import Missing from "./components/Missing";
import Layout from "./components/Layout";
import Unauthorized from "./components/Unauthorized";
import LoginScreen from "./components/Login/LoginScreen";
import { useEffect, useState } from "react";
import useAuth from "./hooks/useAuth";
import DeviceFirmwareUpdate from "./components/Administration/DeviceFirmwareUpdate";
import MasterRunninghrs from "./components/Administration/MasterRunninghrs";

const Dashboard = lazy(() => import("./components/DashBoard/Dashboard"));
const OperationalDashboard = lazy(
  () => import("./components/DashBoard/OperationalDashboard"),
);
const Administration = lazy(
  () => import("./components/Administration/Administration"),
);
const AdministratorMasterData = lazy(
  () => import("./components/Administration/AdministratorMasterData"),
);
const EquipmentDetails = lazy(
  () => import("./components/Administration/EquipmentDetails"),
);
const Alerts = lazy(() => import("./components/Alerts/Alerts"));
const Settings = lazy(() => import("./components/Settings/Settings"));

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const { auth, setAuth } = useAuth();

  useEffect(() => {
    function hideError(e) {
      if (
        e.message ===
        "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div",
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay",
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    }

    window.addEventListener("error", hideError);
    return () => {
      window.removeEventListener("error", hideError);
    };
  }, []);

  useEffect(() => {
    // Perform authentication and setAuthState logic here
    const loginUserJSON = sessionStorage.getItem("loginUser");
    let timeoutId;
    if (loginUserJSON) {
      try {
        const loginUser = JSON.parse(loginUserJSON);
        const accessToken = loginUser.accessToken;
        const role = loginUser.role;
        const user = loginUser.user;
        const clientId = loginUser.clientId;
        const pages = loginUser.pages;
        setAuth({
          role,
          accessToken,
          clientId,
          user,
          pages,
        });
        // Function to reset the inactivity timer
        const resetTimer = () => {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(
            () => {
              setAuth({});
              sessionStorage.removeItem("loginUser");
            },
            60 * 60 * 1000,
          ); // 1 hour in milliseconds
        };

        // Attach event listeners to detect user activity
        window.addEventListener("mousemove", resetTimer);
        window.addEventListener("keydown", resetTimer);

        // Initialize the timer on component mount
        resetTimer();
        setIsLoading(false);
        // Clean up event listeners and timeout on component unmount
        return () => {
          clearTimeout(timeoutId);
          window.removeEventListener("mousemove", resetTimer);
          window.removeEventListener("keydown", resetTimer);
        };
      } catch (error) {
        console.error("Failed to parse loginUser:", error);
      }
    }
    setIsLoading(false);
  }, [setAuth]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Suspense fallback={<div>Loading page...</div>}>
      <Routes>
        {/* public routes */}
        <Route path="/login" element={<LoginScreen />} />
        <Route path="unauthorized" element={<Unauthorized />} />

        {/* we want to protect these routes */}
        {/* <Route path="/" element={<Layout />}>
        <Route element={<RequireAuth />}>
          <Route index element={<Dashboard />} />
          <Route
            path="/operational-dashboard"
            element={<OperationalDashboard />}
          />
          <Route path="/administrator" element={<Administration />} />
          <Route
            path="/administratorMasterData"
            element={<AdministratorMasterData />}
          />
          <Route path="/equipmentDetails" element={<EquipmentDetails />} />
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Route> */}
        <Route path="/" element={<Layout />}>
          <Route element={<RequireAuth allowedPages={["HO Dashboard"]} />}>
            <Route index element={<Dashboard />} />
          </Route>

          <Route
            element={<RequireAuth allowedPages={["Operational Dashboard"]} />}
          >
            <Route
              path="/operational-dashboard"
              element={<OperationalDashboard />}
            />
          </Route>

          <Route
            element={
              <RequireAuth
                allowedPages={[
                  "User Master",
                  "Equipment Master",
                  "Iot Devices Master",
                  "Machine Breakdown hrs",
                  "Override Approval",
                  "Device Firmware Update",
                ]}
              />
            }
          >
            <Route path="/administrator" element={<Administration />} />
            <Route
              path="/administratorMasterData"
              element={<AdministratorMasterData />}
            />
            <Route path="/equipmentDetails" element={<EquipmentDetails />} />
            <Route
              path="/deviceFirmwareUpdate"
              element={<DeviceFirmwareUpdate />}
            />
          </Route>

          <Route element={<RequireAuth allowedPages={["Alerts"]} />}>
            <Route path="/alerts" element={<Alerts />} />
          </Route>

          <Route element={<RequireAuth allowedPages={["Settings"]} />}>
            <Route path="/settings" element={<Settings />} />
          </Route>

          <Route element={<RequireAuth />}>
            <Route path="/masterRunninghrs" element={<MasterRunninghrs />} />
          </Route>
        </Route>

        {/* catch all */}
        <Route path="*" element={<Missing />} />
      </Routes>
    </Suspense>
  );
}

export default App;
